module.exports = __webpack_public_path__ + "static/step-6.7b8e1dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/dialogs/step-6.png
// module id = 2559
// module chunks = 271209794080471